import getDocRef from './getDocRef'
import { setDoc } from 'firebase/firestore/lite'

const updateDataById = async (id, getCollection, obj) => setDoc(getDocRef(id, getCollection()), obj, { merge: true })

export default updateDataById
